export default "__VITE_ASSET__22997e69__"